import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "campaign-form",
  class: "salesforce-campaign-form"
}
const _hoisted_2 = { class: "form-toolbar" }
const _hoisted_3 = { class: "info-card" }
const _hoisted_4 = { class: "card-grid" }
const _hoisted_5 = { class: "field-group full-width" }
const _hoisted_6 = { class: "field-group" }
const _hoisted_7 = { class: "field-group" }
const _hoisted_8 = { class: "field-group" }
const _hoisted_9 = { class: "field-group" }
const _hoisted_10 = { class: "field-group" }
const _hoisted_11 = { class: "field-group full-width" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolbarForm = _resolveComponent("ToolbarForm")!
  const _component_FormTextbox = _resolveComponent("FormTextbox")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_DxDateBox = _resolveComponent("DxDateBox")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxValidationGroup = _resolveComponent("DxValidationGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxValidationGroup, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ToolbarForm, {
            "is-editing": _ctx.isEditing,
            "is-disabled": _ctx.isLocked,
            onEditCanceled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelEdit())),
            onEditToggled: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startEdit())),
            onSaveClicked: _ctx.handleSaveClick
          }, null, 8, ["is-editing", "is-disabled", "onSaveClicked"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "field-label" }, "Denumire Campanie", -1)),
              _createVNode(_component_FormTextbox, {
                modelValue: _ctx.internalCampaignData.Denumire,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.internalCampaignData.Denumire) = $event)),
                "is-editing": _ctx.isEditing,
                "show-label": false
              }, null, 8, ["modelValue", "is-editing"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "field-label" }, "Industrie", -1)),
              _createVNode(_component_DxSelectBox, {
                modelValue: _ctx.internalCampaignData.IndustrieID,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.internalCampaignData.IndustrieID) = $event)),
                "data-source": _ctx.dsIndustrii,
                "display-expr": "Nume",
                "value-expr": "ID",
                "search-enabled": true,
                "read-only": !_ctx.isEditing,
                placeholder: "Selectează industrie"
              }, null, 8, ["modelValue", "data-source", "read-only"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "field-label" }, "Buget Estimat", -1)),
              _createVNode(_component_DxNumberBox, {
                modelValue: _ctx.internalCampaignData.Buget,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.internalCampaignData.Buget) = $event)),
                "read-only": !_ctx.isEditing,
                format: "#,##0.00 RON",
                showSpinButtons: false,
                width: "100%"
              }, null, 8, ["modelValue", "read-only"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "field-label" }, "Dată Start", -1)),
              _createVNode(_component_DxDateBox, {
                modelValue: _ctx.internalCampaignData.DataStart,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.internalCampaignData.DataStart) = $event)),
                type: "date",
                "display-format": "dd.MM.yyyy",
                "read-only": !_ctx.isEditing
              }, null, 8, ["modelValue", "read-only"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "field-label" }, "Dată Sfârșit", -1)),
              _createVNode(_component_DxDateBox, {
                modelValue: _ctx.internalCampaignData.DataEnd,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.internalCampaignData.DataEnd) = $event)),
                type: "date",
                "display-format": "dd.MM.yyyy",
                "read-only": !_ctx.isEditing
              }, null, 8, ["modelValue", "read-only"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "field-label" }, "Campanie Activă", -1)),
              _createVNode(_component_DxCheckBox, {
                modelValue: _ctx.internalCampaignData.CurentActiv,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.internalCampaignData.CurentActiv) = $event)),
                "read-only": !_ctx.isEditing,
                text: "Activ"
              }, null, 8, ["modelValue", "read-only"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "field-label" }, "Explicație / Note", -1)),
              _createVNode(_component_DxTextArea, {
                modelValue: _ctx.internalCampaignData.Explicatie,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.internalCampaignData.Explicatie) = $event)),
                "read-only": !_ctx.isEditing,
                height: 120,
                placeholder: "Adaugă detalii suplimentare..."
              }, null, 8, ["modelValue", "read-only"])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}